import React from 'react';
import Table from '@ui-library/table';
import Modal from '@ui-library/modal/error';
import classes from './errors/report-errors-view.module.scss';
import { METRIC_TYPE } from './Report';

export interface MetricProps {
  updates?: number;
  deletes?: number;
  inserts?: number;
  type?: string;
  syncing?: boolean;
  taskRunId?: string;
  jobRunId?: string;
  syncType?: string;
}
interface MetricModalProps {
  data: MetricProps;
  onClose: () => void;
}
const isFullSync = (syncType?: string) => syncType?.toLowerCase() === 'full';
const metricColumns = [
  {
    title: <div className={classes.header_column}>INSERTS</div>,
    dataIndex: 'inserts',
    render: (data: number) => data.toLocaleString(),
  },
  {
    title: <div className={classes.header_column}>DELETES</div>,
    dataIndex: 'deletes',
    render: (deletes: number, rowData: MetricProps) =>
      isFullSync(rowData.syncType) ? '*' : deletes.toLocaleString(),
  },
  {
    title: <div className={classes.header_column}>UPDATES</div>,
    dataIndex: 'updates',
    render: (updates: number, rowData: MetricProps) =>
      isFullSync(rowData.syncType) ? '*' : updates.toLocaleString(),
  },
];

const MetricTable: React.FC<{ data: MetricProps }> = ({ data }: { data: MetricProps }) => (
  <Table
    columns={metricColumns}
    dataSource={data.syncing ? [] : [data]}
    pagination={false}
    loading={data.syncing}
  />
);

const MetricModal: React.FC<MetricModalProps> = ({ data, onClose }: MetricModalProps) => {
  const getHeaderText = () =>
    data.type === METRIC_TYPE.DELTAS
      ? 'INSERTS, DELETES, UPDATES detected in source'
      : 'Successful INSERTS, DELETES, UPDATES occured in the destination';
  const getSubHeaderText = () =>
    data.type === METRIC_TYPE.SUCCESSFUL && data.syncing ? 'Wait for the sync to finish' : '';
  return (
    <Modal
      view={
        <>
          <MetricTable data={data} />
          {isFullSync(data.syncType) && (
            <div className={classes.full_sync_message}>
              * This run is a Mirror Mode (Full Sync), which clears the destination before inserting
              records from the Reverse ETL.{' '}
            </div>
          )}
        </>
      }
      showBackButton={false}
      header={getHeaderText()}
      subHeader={getSubHeaderText()}
      onClose={onClose}
    />
  );
};

export default MetricModal;
